import redirectionApi from '@/api/redirection.api'
import { isRebondVisiblePourAdherent } from '@/utils/public-vise'

const getDefaultState = () => {
  return {
    redirections: [],
    redirection: {},
    pagesOrigines: [],
    pictogrammes: [],
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    redirections (state) {
      return state.redirections
    },
    redirection (state, getters, rootState, rootGetters) {
      const abonnements = rootGetters['adherent/abonnements']

      if (!isRebondVisiblePourAdherent(state.redirection, abonnements?.culturialAbonne)) {
        return null
      }

      return state.redirection
    },
    pagesOrigines (state) {
      return state.pagesOrigines
    },
    pictogrammes (state) {
      return state.pictogrammes
    },
  },

  mutations: {
    UPDATE_REDIRECTIONS (state, redirections) {
      state.redirections = redirections
    },
    UPDATE_REDIRECTION (state, redirection) {
      state.redirection = redirection
    },
    UPDATE_PAGES_ORIGINES (state, pagesOrigines) {
      state.pagesOrigines = pagesOrigines
    },
    UPDATE_PICTOGRAMMES (state, pictogrammes) {
      state.pictogrammes = pictogrammes
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getRedirections ({ commit }) {
      return redirectionApi.getRedirections()
        .then(response => {
          commit('UPDATE_REDIRECTIONS', response)
        })
    },
    getRedirection ({ commit }, path) {
      return redirectionApi.getRedirection(path)
        .then(response => {
          commit('UPDATE_REDIRECTION', response)
        })
    },
    getPagesOrigines ({ commit }) {
      return redirectionApi.getPagesOrigines()
        .then(response => {
          commit('UPDATE_PAGES_ORIGINES', response)
        })
    },
    getPictogrammes ({ commit }) {
      return redirectionApi.getPictogrammes()
        .then(response => {
          commit('UPDATE_PICTOGRAMMES', response)
        })
    },
    createOrUpdateRedirection ({ dispatch }, redirection) {
      let promiseUpdate
      if (redirection.id) {
        promiseUpdate = redirectionApi.updateRedirection(redirection)
      } else {
        promiseUpdate = redirectionApi.createRedirection(redirection)
      }
      return promiseUpdate.then(() => dispatch('getRedirections'))
    },
    deleteRedirection ({ dispatch }, redirection) {
      return redirectionApi.deleteRedirection(redirection.id)
        .then(() => dispatch('getRedirections'))
    },
    createRedirectionUtilisation ({ rootGetters }, redirectionUtilisation) {
      const username = rootGetters['user/profil'].username
      return redirectionApi.createRedirectionUtilisation(username, redirectionUtilisation)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
